(() => {
const init = (root = document) => {
root.querySelectorAll('[data-bhs-videos]').forEach(section => {
if (section.dataset.bhsReady) return;
section.dataset.bhsReady = 'true';
const dialog = section.querySelector('dialog');
const frame = dialog.querySelector('iframe');
const heading = dialog.querySelector('h2');
let trigger;
section.addEventListener('click', event => {
const launch = event.target.closest('[data-video-id]');
if (launch) {
const id = launch.dataset.videoId;
if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
trigger = launch;
heading.textContent = launch.dataset.videoName;
frame.title = launch.dataset.videoName;
frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
dialog.showModal();
}
if (event.target.closest('[data-bhs-video-close]')) dialog.close();
});
dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
dialog.addEventListener('close', () => { frame.removeAttribute('src'); if (trigger) trigger.focus(); });
const filter = section.querySelector('[data-bhs-video-filter]');
filter.addEventListener('input', () => {
const query = filter.value.trim().toLowerCase();
let shown = 0;
section.querySelectorAll('[data-video-title]').forEach(card => { card.hidden = !card.dataset.videoTitle.toLowerCase().includes(query); if (!card.hidden) shown++; });
section.querySelector('[data-bhs-video-empty]').hidden = shown !== 0;
});
});
root.querySelectorAll('.bhs-disability-section').forEach(section => {
if (section.dataset.bhsReady) return;
section.dataset.bhsReady = 'true';
const track = section.querySelector('.bhs-disability-track');
const buttons = section.querySelectorAll('[data-bhs-scroll]');
const update = () => { const max = track.scrollWidth - track.clientWidth; buttons.forEach(button => { button.disabled = max < 2 || (Number(button.dataset.bhsScroll) < 0 ? track.scrollLeft < 2 : track.scrollLeft >= max - 2); }); };
buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({left:Number(button.dataset.bhsScroll) * (track.clientWidth * .85),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
track.addEventListener('scroll', update, {passive:true});
if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
update();
});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
document.addEventListener('shopify:section:load', event => init(event.target));
})();